(function () {
  'use strict'

  const MODULE_NAME = 'thismoment.glow.component.glow-cart'
  const templateUrl = require('./tpl/glow-cart.html')
  const modalTemplateUrl = require('./tpl/cart-modal.html')
  const buttonTemplateUrl = require('./tpl/cart-buttons.html')
  const Msnry = require('masonry-layout')
  const ImagesLoaded = require('imagesloaded')
  const Sortable = require('sortablejs').Sortable

  require('./scss/glow-cart.scss')
  require('./scss/cart-modal.scss')

  require('angular')
    .module(MODULE_NAME, [
      require('angular-ui-bootstrap/src/buttons'),
      require('../../../modal'),
      require('../../../content/content-api'),
      require('../glow-modal'),
      require('./component/cart-card'),
      require('./service/glow-cart'),
      require('./provider/cart-api'),
      require('./cart-item')
    ])
    .component('thismomentGlowCart', {
      templateUrl: templateUrl,
      controller: thismomentGlowCartController
    })

  thismomentGlowCartController.$inject = ['$location', '$timeout', '$rootScope', '$scope', '$element', '$stateParams', 'SdkConfig', 'analyticsSDK', 'Cart', 'CartApi', 'ContentApi', 'GlowConfig', 'Modal']
  function thismomentGlowCartController ($location, $timeout, $rootScope, $scope, $element, $stateParams, SdkConfig, analyticsSDK, Cart, CartApi, ContentApi, GlowConfig, Modal) {
    const vm = this
    const CartConfig = GlowConfig.getCart()

    vm.path = $stateParams.path
    vm.$onInit = cartInit
    vm.launchGlowCart = launchGlowCart

    function cartInit () {
      vm.styles = {
        header: {
          'background-color': CartConfig.get('header_background_color')
        }
      }

      vm.cartLinkLabel = CartConfig.get('cart_link_label')

      $rootScope.$on('cart:add', updateCartCount)
      $rootScope.$on('cart:remove', updateCartCount)

      updateCartCount()

      if ($stateParams.modal === 'cart') {
        launchGlowCart(true)
      }
    }

    function updateCartCount () {
      vm.cartCount = Cart.getIds().length
    }

    function launchGlowCart (deeplink) {
      // analytics
      vm.trackEvent = analyticsSDK.setupEventTracking({})
      vm.trackEvent('Cart Explored', {
        'event trigger': (deeplink) ? 'deeplinked to cart' : 'clicked cart'
      })

      // modal settings
      $scope.ariaLabel = 'Send your content'
      $scope.cancelBackgroundColor = null
      $scope.cancelColor = null
      $scope.cancelText = 'Cancel'
      $scope.errorButtonText = 'Continue'
      $scope.errorColor = null
      $scope.errorDescription = 'Please try sending your cart again'
      $scope.errorTitle = 'Error'
      $scope.submissionBackgroundColor = null
      $scope.submissionBackgroundImage = null
      $scope.submissionFormDescription = null
      $scope.submissionFormDescriptionColor = null
      $scope.submissionFormTitle = null
      $scope.submissionFormTitleColor = null
      $scope.submitBackgroundColor = CartConfig.get('send_button_color')
      $scope.submitColor = CartConfig.get('send_button_text_color')
      $scope.submitText = CartConfig.get('send_button_text')
      $scope.successButtonText = 'Continue'
      $scope.successColor = CartConfig.get('send_button_color')
      $scope.successDescription = null
      $scope.successTitle = 'Thank you'

      $scope.canAddMoreUsers = true
      $scope.endUserCount = 0
      $scope.endUserMax = 25
      $scope.formData = {}

      var deliveryFields
      if (CartConfig.get('delivery_method') === 'email_html' || CartConfig.get('delivery_method') === 'email_link') {
        $scope.formData.email_subject = CartConfig.get('email_subject')
        $scope.formData.email_body = CartConfig.get('email_template')

        deliveryFields = [
          {
            key: 'recipients',
            fieldGroup: []
          },
          {
            key: 'add_remove_customer',
            templateUrl: buttonTemplateUrl,
            templateOptions: {
              endUserCount: $scope.endUserCount,
              endUserMax: $scope.endUserMax,
              canAddMoreUsers: $scope.canAddMoreUsers,
              removeEndUser: removeEndUser,
              addEndUser: addEndUser
            },
            expressionProperties: {
              'templateOptions.endUserCount': ($viewValue, $modelValue, scope) => {
                return $scope.endUserCount
              }
            }
          },
          {
            template: '<hr>'
          },
          {
            type: 'checkbox',
            key: 'edit_email',
            templateOptions: {
              label: 'Edit Email'
            }
          },
          {
            key: 'email_subject',
            type: 'input',
            className: 'fade-in',
            hideExpression: '!model.edit_email',
            templateOptions: {
              label: 'Email Subject',
              type: 'input'
            }
          },
          {
            key: 'email_body',
            type: 'textarea',
            className: 'fade-in',
            hideExpression: '!model.edit_email',
            templateOptions: {
              label: 'Email Body',
              rows: 5
            }
          },
          {
            template: '<hr>'
          }
        ]
      } else {
        deliveryFields = []
      }

      $scope.fields = [...deliveryFields, ...CartConfig.get('cart_form_items')]

      $scope.busy = false
      $scope.playlistLoaded = false
      $scope.cartItems = []
      $scope.isCartEmpty = Cart.getIds().length === 0
      $scope.removeItem = removeItem
      if (['758691FDF7', 'NIHHZKZDLS', '762E2A4A6B'].includes(SdkConfig.get('account_id'))) {
        $scope.radioModel = 'preview'
      } else {
        $scope.radioModel = 'edit'
      }

      const expanded = Modal()
      expanded.open({
        animation: false,
        backdrop: 'static',
        component: 'thismomentGlowModal',
        size: 'lg',
        resolve: {
          options: {
            // analytics
            trackEvent: vm.trackEvent,
            parentEvent: 'Cart send',
            parentType: 'Cart',
            // config
            getParentScope: getParentScope, // not using uib's $scope parameter as that does not play nicely
            onSubmit: onSubmit,
            templateUrl: modalTemplateUrl
          }
        }
      }, exitModal, exitModal, null, renderModal)()
      $location.search({modal: 'cart'})

      // init
      if (CartConfig.get('delivery_method') === 'email_html' || CartConfig.get('delivery_method') === 'email_link') {
        addEndUser()
      }

      // functions
      function addEndUser ($event) {
        if (angular.isDefined($event)) {
          $event.preventDefault()
        }
        $scope.endUserCount += 1

        const newEndUserFields = {
          key: 'user_group_' + $scope.endUserCount.toString(),
          fieldGroup: [
            {
              key: 'email',
              type: 'input',
              templateOptions: {
                required: true,
                label: 'Email Address',
                placeholder: 'recipient@example.com'
              }
            },
            {
              key: 'first_name',
              type: 'input',
              templateOptions: {
                required: true,
                label: 'First Name'
              }
            },
            {
              key: 'last_name',
              type: 'input',
              templateOptions: {
                required: true,
                label: 'last Name'
              }
            },
            {
              template: '<hr>'
            }
          ]
        }
        $scope.fields[0].fieldGroup.push(newEndUserFields)
        $rootScope.$emit('formly:runExpressions')
      }

      function removeEndUser ($event) {
        $event.preventDefault()
        if ($scope.endUserCount === 1) {
          return
        }
        // remove the fields
        $scope.fields[0].fieldGroup.pop()

        // remove the model values
        delete $scope.formData.recipients['user_group_' + $scope.endUserCount]

        // decrement the count
        $scope.endUserCount -= 1
        $rootScope.$emit('formly:runExpressions')
      }

      function onSubmit (formData) {
        if ('recipients' in formData) {
          var recipients = []
          for (var key in formData.recipients) {
            recipients.push(formData.recipients[key])
          }
          delete formData.recipients
          formData.emails = recipients
        }
        return CartApi.send(formData, Cart.getIds()).then(function (response) {
          $scope.successDescriptionCopy = true
          $scope.successDescription = response.success
          Cart.empty()
        })
      }

      function getCartContents () {
        return ContentApi.fetch(Cart.getIds())
      }

      function renderModal () {
        // "edit" grid
        vm.editCartSortable = Sortable.create(document.getElementById('edit-cart-items'), {
          animation: 300,
          dataIdAttr: 'data-id',
          draggable: '.edit-cart-card',
          easing: 'cubic-bezier(0.87, 0, 0.13, 1)',
          filter: '.square-left',
          group: 'edit-cart',
          handle: '.overlay',
          ghostClass: 'sort-placeholder',
          dragClass: 'sort-drag',
          store: {
            get: function () {
              return Cart.getIds()
            },
            set: function (sortable) {
              Cart.setIds(sortable.toArray())
            }
          }
        })

        // "preview" grid
        const previewMsnryGrid = new Msnry('#preview-cart-items', {
          itemSelector: '.grid-item',
          columnWidth: '.grid-sizer'
        })
        previewMsnryGrid.reloadItems()
        previewMsnryGrid.layout()
        refreshMsnry()

        // watcher for edit/preview
        $scope.$watch('radioModel', (newVal) => {
          if ($scope.busy) {
            return
          }
          $scope.playlistLoaded = false
          $scope.busy = true
          $scope.cartItems = []
          getCartContents().then((items) => {
            angular.forEach(items, (item, idx) => {
              // if there is no item, then it has been
              // sent to Pending and should be removed
              // from the cart
              if (!item) {
                var idToRemove = Cart.getIds()[idx]
                Cart.removeItem(idToRemove)
                return
              }
              $scope.cartItems.push(item)
            })
            $scope.busy = false
            $scope.playlistLoaded = true
            if (newVal === 'preview') {
              refreshMsnry()
            }
          })
        })

        // these timeouts are to make masonry jive with angular
        function refreshMsnry () {
          $timeout(() => {
            const previewImgs = ImagesLoaded('#preview-cart-items')
            previewImgs.on('progress', () => {
              $timeout(() => {
                previewMsnryGrid.reloadItems()
                previewMsnryGrid.layout()
              }, 0)
            })
            previewImgs.on('always', () => {
              $timeout(() => {
                previewMsnryGrid.reloadItems()
                previewMsnryGrid.layout()
              }, 0)
            })
          }, 0)
        }
      }

      function exitModal () {
        $location.search({ modal: null, moduleId: null })
        $element[0].focus() // use raw HTML element's `focus` method
      }

      function getParentScope () {
        return $scope
      }

      function removeItem (id) {
        var idx = Cart.removeItem(id)
        var removeList = document.getElementById('remove-cart-items')
        var elementToRemove = removeList.children[idx]
        elementToRemove.remove()
        $scope.isCartEmpty = Cart.getIds().length === 0
        $rootScope.$emit('cart:reorder')
      }
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/component/glow-cart/index.js